import React, { useRef } from 'react';
import TruncateTextCmp from 'src/components/TruncateText';

interface IProps {
    columnName?: string;
    data?: { column?: any; row?: any; context?: any } | null;
}

/** Preview value inside a column-manager card: the column's getValue against the first table row. */
const RouteOverviewDraggableCell = ({ data }: IProps) => {
    const valueRef = useRef<HTMLParagraphElement>(null);
    const column = data?.column;
    const width = column?.previewWidth || '130px';
    const sizing = { minWidth: width, maxWidth: width, width };
    const value = column?.getValue && data?.row ? column.getValue(data.row, data?.context) : null;
    const isText = typeof value === 'string' || typeof value === 'number';

    if (!isText) {
        return <div style={sizing}>{value ?? '-'}</div>;
    }

    const text = String(value).trim() || '-';

    return (
        <div style={sizing}>
            <TruncateTextCmp message={text} refName={valueRef}>
                <p className="truncate" ref={valueRef}>
                    {text}
                </p>
            </TruncateTextCmp>
        </div>
    );
};

export default RouteOverviewDraggableCell;
